"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Spinner = _styledComponents.default.div`
  width: ${props => props.size ? `${props.size}px` : '40px'};
  height: ${props => props.size ? `${props.size}px` : '40px'};

  position: relative;
  margin: 0 auto;
`;
const Bounce = (0, _styledComponents.keyframes)`
  0%, 100% {
    transform: scale(0.0);
  } 50% {
    transform: scale(1.0);
  }
`;
const DoubleBounce = _styledComponents.default.div`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: #333;
  opacity: 0.6;
  position: absolute;
  top: 0;
  left: 0;

  animation: ${Bounce} 2s infinite ease-in-out;
`;
const DoubleBounce2 = (0, _styledComponents.default)(DoubleBounce)`
  animation-delay: -1s;
`;

// eslint-disable-next-line react/display-name
function CircleLoader(_ref) {
  let {
    size
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(Spinner, {
    size: size
  }, /*#__PURE__*/_react.default.createElement(DoubleBounce, null), /*#__PURE__*/_react.default.createElement(DoubleBounce2, null));
}
CircleLoader.propTypes = {
  size: _propTypes.default.number
};
CircleLoader.defaultProps = {
  size: 40
};
var _default = exports.default = CircleLoader;
//# sourceMappingURL=CircleLoader.js.map